module.exports = __webpack_public_path__ + "static/02-1-ec5c635f1b966e4d43fdf459b324e109.jpg";